import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { isPlainObject, isNil, isString } from 'lodash-es';
import { Observable, map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export function canActivate(
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  const a: any = route.data;
  const roles = 'Roles' in a ? a.Roles : null;
  const needed: string[] = Array.isArray(roles)
    ? roles.filter((a: any) => isString(a) && a.length > 0)
    : [];
  const svc = inject(AuthService);
  return svc.requestLogin().pipe(
    map((a) => {
      if (isNil(a) || !isPlainObject(a)) return false;
      if (needed.length === 0) return true;
      if (!Array.isArray(a.roles)) return false;
      return needed.every((b) => {
        if (a.roles.includes(b)) return true;
        if (b.includes('|'))
          return b.split('|').some((c) => a.roles.includes(c));
        return false;
      });
    })
  );
}
